import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <TopicsSection />
        <IndexSection />
        <RankingSection />
        <UpdatesSection />
        <FeaturesSection />
        <CardsSection />
        <CarouselSection />
        <MediaSection />
        <CommentsSection />
        <AboutSection />
        <ContactSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}